import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHomeDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4374_1150)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9786 19.8838C11.8681 18.9007 12.4796 19.4502 12.4796 19.4502C14.3106 19.6175 14.0638 20.034 13.5206 23.0654C12.9783 26.0972 12.0883 20.8677 11.9786 19.8838ZM4.99817 17.3516C5.75969 16.2054 6.03814 17.0732 6.0382 17.0732C6.04557 17.079 6.25446 17.2438 6.83898 17.9297C7.43407 18.6279 6.00704 19.5262 4.90931 20.207C3.81341 20.8863 3.37643 20.9274 3.66615 20.4072C3.95681 19.8858 4.23757 18.4971 4.99817 17.3516ZM16.7999 16.6533C17.2266 16.1506 17.6451 16.3084 17.6583 16.3135C19.6485 18.8374 17.3093 18.0991 16.6778 17.8369C16.0474 17.5748 16.3663 17.1635 16.7999 16.6533ZM10.6642 6.99812C11.831 6.61471 14.9851 7.70636 16.0753 11.3789C17.1651 15.0516 14.5393 16.9237 11.5743 17.4697H11.5733C8.60745 18.0153 6.3878 15.2181 6.17492 11.626C5.96359 8.03393 10.6642 6.99812 10.6642 6.99812ZM2.839 10.8877C3.89024 10.9338 3.40265 12.0048 3.34974 12.793C3.29577 13.5816 2.69062 13.3629 1.46108 12.877C0.230836 12.3913 -0.495539 11.9415 0.395659 11.6465C1.28585 11.3524 2.48185 10.8726 2.839 10.8877ZM17.8897 11.5274C17.8575 10.4781 18.7764 10.7608 18.7764 10.7608C24.918 10.7689 22.4221 11.3114 20.044 12.2246C17.6666 13.138 17.9232 12.5779 17.8897 11.5274ZM17.4083 4.66415C17.8455 4.50537 17.9578 4.79404 17.7081 5.01083C17.4573 5.22782 16.5803 6.86269 16.0333 7.67097C15.4863 8.47827 14.7227 7.32526 14.7227 7.32526C13.4117 5.96658 17.4083 4.66415 17.4083 4.66415ZM2.47963 4.24228C2.00143 3.84707 3.77563 4.26568 5.1427 5.37411C5.14569 5.37733 6.21564 6.53513 5.74817 7.00691C5.28187 7.47885 4.51878 7.53212 4.02845 6.81062C3.53904 6.08851 2.95592 4.63813 2.47963 4.24228ZM6.92785 0.659295C6.49162 -1.32294 8.65808 1.7228 9.24131 2.49815C9.8245 3.27433 10.0637 4.2809 8.61241 4.86337C7.17378 5.4406 7.3746 3.47135 7.37804 3.43857C7.37804 3.43857 7.36336 2.6414 6.92785 0.659295Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M35.4518 71.6283C35.7146 72.2852 35.2308 72.9997 34.5233 72.9997H29.4774C28.7699 72.9997 28.2862 72.2852 28.5489 71.6283L31.0719 65.3209C31.4071 64.4827 32.5936 64.4827 32.9288 65.3209L35.4518 71.6283ZM30.3988 70.6578C30.1615 71.31 30.6445 71.9997 31.3385 71.9997H33.0459C33.7534 71.9997 34.2371 71.2852 33.9744 70.6284L33.0804 68.3928C32.7395 67.5402 31.5261 67.5593 31.2122 68.4222L30.3988 70.6578Z",
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M55 29L58 35V29H63.3408L71.9121 49H45.207L45.5898 49.9258L45.748 50.3984L45.8047 50.4434L59.293 83H55.6592L32.5166 29H55Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 68.5,
				y: 74.5,
				width: 5,
				height: 11,
				rx: .5,
				stroke: "white",
				strokeOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 77.5,
				y: 74.5,
				width: 5,
				height: 11,
				rx: .5,
				stroke: "white",
				strokeOpacity: .24
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M50 23H58V35L55 29H50V23Z",
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M43.5523 13.4877C43.8069 12.6107 44.8819 12.2995 45.5891 12.837C46.4661 11.2529 49.0122 11.8468 48.9839 13.7422C50.5398 13.714 50.2004 16.2034 48.701 15.779C48.3048 16.5711 47.2582 16.7125 46.6358 16.1185C46.0983 17.1936 44.4574 16.9955 44.2029 15.779C41.8549 17.1086 41.0061 13.6573 43.5522 13.4875L43.5523 13.4877Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M89.5415 24.5207C89.1358 23.0825 87.3659 22.5662 86.2227 23.4882C84.7846 20.9069 80.6174 21.8657 80.6915 24.9631C78.1102 24.9263 78.6634 29.0194 81.134 28.2819C81.7978 29.5726 83.3096 29.8308 84.4159 28.9087C84.5266 29.0562 84.6003 29.1669 84.7109 29.2776C86.0016 30.6418 88.5091 29.9414 88.6936 28.2819C89.7629 29.0562 91.8648 28.5032 91.9017 26.6594C91.9385 25.7376 90.7954 24.4099 89.5418 24.5206L89.5415 24.5207Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M59.5 95H56V84H59.5V95Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M90 88C92.2091 88 94 89.7909 94 92V95H87V89.3555C87.733 88.5246 88.805 88 90 88Z",
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 59.5,
				y: 83,
				width: 1,
				height: 12,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M64 64.9805V65L47.4229 51.7383L47.4121 51.7109L64 64.9805ZM87 63.9326V65H65V64.5L64.375 64H69.5L70.3135 64.8135H82.3135L81.5 64H85.6924L72.5674 50H46.875L45.625 49H73L87 63.9326ZM80.6064 64.1064H76.1064L76 64H80.5L80.6064 64.1064ZM75.1064 64.1064H70.6064L70.5 64H75L75.1064 64.1064ZM45.8047 50.4434L45.748 50.3984L45.5898 49.9258L45.8047 50.4434Z",
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M65.5156 53.5156C68.7747 53.6957 73.0183 55.5186 75.2422 57.7422L81.5 64H80.5L74.2422 57.7422C74.1795 57.6795 74.1143 57.6176 74.0478 57.5557H69.5557L76 64H75L68.5557 57.5557H64.0625C64.1197 57.6174 64.1796 57.6796 64.2422 57.7422L70.5 64H69.5L63.2422 57.7422C61.0184 55.518 61.6148 53.6949 64.5156 53.5156L64.5 53.5H65.5L65.5156 53.5156ZM65.2246 54.2246C63.2709 54.3721 62.6203 55.439 63.5107 56.8486H67.8486L65.2246 54.2246ZM68.8486 56.8486H73.1875C71.2587 55.4392 68.4731 54.3722 66.2246 54.2246L68.8486 56.8486Z",
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M65.3838 25.3203L64.1904 28H64H63.5483H63.0967L64.4707 24.9131L65.3838 25.3203Z",
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M63.6299 26.7998L63.0967 28H63.0371L61.9229 25.2422L62.8496 24.8672L63.6299 26.7998Z",
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.084 28H31V28.002L29.8457 25.2832L30.7656 24.8926L32.084 28ZM34.3838 25.3203L33.1904 28H32.0967L33.4707 24.9131L34.3838 25.3203Z",
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9 84.2041V95H8V84L32 28L56 84V95H55V84.2041L32 30.5371L9 84.2041Z",
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M50 29H32.5166L55.6592 83H59.5V83.5V84H56L32 28L31.5 29.166L31 28H50V29ZM73 49H71.9121L63.3408 29H58V28H64L73 49Z",
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M65 64.5V95H64V64.9805L47.4121 51.7109L60.375 83H59.293L45.207 49H45.625L65 64.5Z",
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8 95H7V93.5C7 92.8471 7.41766 92.293 8 92.0869V95ZM3.5 88C4.88071 88 6 89.1193 6 90.5V95H1V90.5C1 89.1193 2.11929 88 3.5 88Z",
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M36 80C36.5523 80 37 80.4477 37 81V95H27V81C27 80.4477 27.4477 80 28 80H36Z",
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				y: 95,
				width: 96,
				height: 1,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M87 95H86V65H87V95ZM70.6064 64.1064H75.1064L75 64H76L76.1064 64.1064H80.6064L80.5 64H81.5L82.3135 64.8135H70.3135L69.5 64H70.5L70.6064 64.1064Z",
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.8311 32.4766L11 84.0811V95.0811H9V84.2041L32 30.5371L32.8311 32.4766Z",
				fill: "#8588D8"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4374_1150",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 96,
			height: 96,
			fill: "white"
		})
	}) })]
});
export default SvgHomeDark;
